import React from 'react';
import { Seed, SeedItem, SeedTeam, SeedTime } from '../components/seed';
import { RoundTitle } from '../components/round';
import { IRenderSeedProps } from '../types/Seed';

/* ------------------------- default title component ------------------------ */
export const renderTitle = (title: string | JSX.Element) => <RoundTitle>{title}</RoundTitle>;

/* ------------------------- default seed component ------------------------- */
export const renderSeed = ({ seed, breakpoint }: IRenderSeedProps) => {
  const status1 = seed.teams?.[0].status;
  const name1 = seed.teams?.[0].name;
  const image1 = seed.teams?.[0].image;

  const status2 = seed.teams?.[1].status;
  const name2 = seed.teams?.[1].name;
  const image2 = seed.teams?.[1].image;

  return (
    <Seed mobileBreakpoint={breakpoint}>
      <SeedItem>
        <div>
          <SeedTeam status={status1}>
            {image1 && <img className='image' src={image1}  alt={name1 || ''} />}

            <div className='text'>
              <span className='title'>{name1 || '-----------'}</span>

              <span className='status'>{status1 || '-'}</span>
            </div>
          </SeedTeam>

          <SeedTeam status={status2}>
            {image2 && <img className='image' src={image2}  alt={name2 || ''} />}

            <div className='text'>
              <span className='title'>{name2 || '-----------'}</span>

              <span className='status'>{status2 || '-'}</span>
            </div>
          </SeedTeam>
        </div>
      </SeedItem>
      
      {seed?.date && <SeedTime mobileBreakpoint={breakpoint}>{seed?.date}</SeedTime>}
    </Seed>
  );
};
